<template>
  
  <v-container fill-height fluid>
    <v-row>
      <v-col align="center"  justify="center">

      <v-img alt="logo" max-width="70%" src="/img/logo.png"> </v-img>

        </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
